<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-auto">
                <h1 class="m-0 text-dark"><label>{{ 'UpdateConfigurationInformation_title' | translate }}</label></h1>
            </div>
            <div class="col-md-auto ml-auto">
                <button (click)="cancel()" class="btn btn-outline-primary d-inline-flex"><span
                    class="material-icons mr-1">close</span>{{ 'btn_cancel' | translate }}</button>
            </div>
            <div class="col-md-auto">
                <button (click)="save()" class="btn btn-primary d-inline-flex mr-3"><span
                    class="material-icons mr-1">save</span>{{ 'btn_save' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<section class="content">
    <div class="container-fluid">
        <div class="">
            <div class="content-right-sidebar tab-bar-border-bottom border-tab mb-4">
                <ul class="nav nav-tabs" id="tabSignAction" role="tablist">
                    <li class="nav-item nav-material">
                        <a class="nav-link cursor-pointer d-flex p-3" [class.active]="tabSelected === 'CMND'"
                            aria-controls="idcard" aria-selected="true"
                            (click)="selectTab('CMND')">
                            <span class="material-icons">card_membership</span>
                            {{ 'UpdateConfigurationInformation_label_1' | translate }}
                        </a>
                    </li>
                    <li class="nav-item nav-material">
                        <a class="nav-link cursor-pointer d-flex p-3" [class.active]="tabSelected === 'PASSPORT'"
                            aria-controls="passport" aria-selected="false"
                            (click)="selectTab('PASSPORT')">
                            <span class="material-icons">card_membership</span>
                            {{ 'UpdateConfigurationInformation_label_2' | translate }}
                        </a>
                    </li>

                    <li class="nav-item nav-material">
                        <a class="nav-link cursor-pointer d-flex p-3" [class.active]="tabSelected === 'CCCD'" 
                            aria-controls="citizen-id-with-chip" aria-selected="false"
                            (click)="selectTab('CCCD')">
                            <span class="material-icons">memory</span>
                            {{ 'UpdateConfigurationInformation_label_3' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content contract-tab-body" id="tabSignAction">
            <div class="tab-pane fade" [class.active]="tabSelected === 'CMND'" [class.show]="tabSelected === 'CMND'" >
                <app-update-idcard *ngIf="tabSelected === 'CMND'"></app-update-idcard>
            </div>
            <div class="tab-pane fade" [class.active]="tabSelected === 'PASSPORT'" [class.show]="tabSelected === 'PASSPORT'" >
                <app-update-passport *ngIf="tabSelected === 'PASSPORT'"></app-update-passport>
            </div>
            <div class="tab-pane fade" [class.active]="tabSelected === 'CCCD'" [class.show]="tabSelected === 'CCCD'" >
                <app-update-citizenid *ngIf="tabSelected === 'CCCD'"></app-update-citizenid>
            </div>
        </div>
    </div>
</section>